import { useMemo } from "react";
import useAuth from "../../../../Hooks/useAuth";
import usePermission from "../../../../Hooks/usePermission";
import { useBelowFirmsData } from "../../../../Hooks/dealerRoles/useBelowFirmsData";
import {
  useSearchDealerUnlinkedFirmsMutation,
  useLinkDealerSubFirmMutation,
  useUnlinkDealerSubFirmMutation,
  useSendDealerSubFirmQuotaMutation,
  useLazyGetDealerSendableSubFirmQuotaQuery,
  useGetDealerRolesCustomersByFirmIdQuery,
} from "../../../../store/dealerRoles/firmApi";
import SubFirmsTab from "../storageRoles/SubFirmsTab";

export default function DealerRolesSubFirmsTab({
  firm,
  onSelectedFirm,
  title,
}) {
  const { auth } = useAuth();
  const { hasPermission } = usePermission();
  // Bayi firmada tek "Müşteriler" sekmesi (#376): alt bayiler + müşteriler
  const isDealerFirm = firm?.firmType === "dealer";
  const canSeeSubDealers = !isDealerFirm || hasPermission("dealers.belowFirms");
  const canSeeCustomers = isDealerFirm && hasPermission("dealers.customers");
  const data = useBelowFirmsData({
    id: canSeeSubDealers ? firm?._id : null,
    token: auth.accessToken,
  });
  const customersQuery = useGetDealerRolesCustomersByFirmIdQuery(
    { token: auth?.accessToken, dealerFirmId: firm?._id },
    { skip: !canSeeCustomers || !auth?.accessToken || !firm?._id }
  );
  const customersSource = useMemo(
    () =>
      isDealerFirm
        ? {
            customers: canSeeCustomers ? customersQuery.data?.data?.customers || [] : [],
            loading: canSeeCustomers && customersQuery.isLoading,
            refetch: customersQuery.refetch,
            // Bayi paneli kuralları (#303): Ver yalnız havuzdan, Al canlı okur
            canSendQuota: hasPermission("customers.sendQuota"),
            canUnlink: false,
            limitToPool: true,
            requireLiveSource: true,
          }
        : null,
    [isDealerFirm, canSeeCustomers, customersQuery.data, customersQuery.isLoading, customersQuery.refetch, hasPermission]
  );

  const [searchUnlinked, { isLoading: searchLoading }] = useSearchDealerUnlinkedFirmsMutation();
  const [linkSubFirm, { isLoading: linkLoading }] = useLinkDealerSubFirmMutation();
  const [unlinkSubFirm, { isLoading: unlinkLoading }] = useUnlinkDealerSubFirmMutation();
  const [sendQuota, { isLoading: sendQuotaLoading }] = useSendDealerSubFirmQuotaMutation();
  const [fetchSendable, { data: sendable, isFetching: sendableFetching }] =
    useLazyGetDealerSendableSubFirmQuotaQuery();

  return (
    <SubFirmsTab
      firm={firm}
      onSelectedFirm={onSelectedFirm}
      title={isDealerFirm ? "Müşteriler" : title}
      externalData={data}
      customersSource={customersSource}
      includeSubDealers={canSeeSubDealers}
      externalHooks={{
        searchUnlinked,
        searchLoading,
        linkSubFirm,
        linkLoading,
        unlinkSubFirm,
        unlinkLoading,
        sendQuota,
        sendQuotaLoading,
        fetchSendable,
        sendable,
        sendableFetching,
      }}
    />
  );
}
